import * as d3 from 'd3';
import line from './line';

const baseline = {
  id: 'baseline',
  label: 'Baseline',
  getYExtent: line.getYExtent,
  draw({ group, data, xScale, yScale, theme, defs }) {
    const baselineValue = d3.mean(data, (d) => d.close);
    const baselineY = yScale(baselineValue);
    const paneHeight = yScale.range()[0]; // d3 y-range is [height, 0] (inverted)
    const splitPct = Math.max(0, Math.min(100, (baselineY / (paneHeight || 1)) * 100));

    defs.selectAll('#baseline-gradient').remove();
    const gradient = defs
      .append('linearGradient')
      .attr('id', 'baseline-gradient')
      .attr('x1', '0%')
      .attr('y1', '0%')
      .attr('x2', '0%')
      .attr('y2', '100%');
    gradient.append('stop').attr('offset', '0%').attr('stop-color', theme.bull.strong).attr('stop-opacity', 0.35);
    gradient.append('stop').attr('offset', `${splitPct}%`).attr('stop-color', theme.bull.strong).attr('stop-opacity', 0.05);
    gradient.append('stop').attr('offset', `${splitPct}%`).attr('stop-color', theme.bear.strong).attr('stop-opacity', 0.05);
    gradient.append('stop').attr('offset', '100%').attr('stop-color', theme.bear.strong).attr('stop-opacity', 0.35);

    group
      .selectAll('.baseline-ref')
      .data([baselineValue])
      .join('line')
      .attr('class', 'baseline-ref')
      .attr('x1', 0)
      .attr('x2', xScale.range()[1])
      .attr('y1', baselineY)
      .attr('y2', baselineY)
      .attr('stroke', theme.axis.text)
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', '4,4')
      .attr('opacity', 0.5);

    const areaGen = d3
      .area()
      .x((d) => xScale(d.date))
      .y0(baselineY)
      .y1((d) => yScale(d.close))
      .curve(d3.curveMonotoneX);

    group
      .selectAll('.mark-area')
      .data([data])
      .join('path')
      .attr('class', 'mark-area')
      .attr('fill', 'url(#baseline-gradient)')
      .attr('d', areaGen);

    line.draw({ group, data, xScale, yScale, theme });
  },
  tooltipFields: line.tooltipFields,
};

export default baseline;
